module.exports = __webpack_public_path__ + "img/mb-outer-loading.21936c01.png";